import { FunctionComponent } from 'preact';
import './MessageCount.css';

export interface MessageCountProps {
  count: number;
  className?: string;
}

export const MessageCount: FunctionComponent<MessageCountProps> = ({
  count,
  className = ''
}) => {
  console.log('MessageCount received count:', count, typeof count);
  
  // Only show the count if it's greater than 0
  if (count <= 0) {
    console.log('MessageCount not displaying because count <= 0');
    return null;
  }

  // Cap the displayed count at 99+
  const displayCount = count > 99 ? '99+' : count.toString();
  console.log('MessageCount displaying:', displayCount);

  return (
    <div className={`message-count ${className}`}>
      {displayCount}
    </div>
  );
};
